// "5m ago" style label for admin lists. Empty string when the value is
// missing or unparseable so callers can render it conditionally.
//
// `nowMs` lets a caller pass the SERVER's current time (client clock +
// measured skew): the timestamps come from the server, so comparing them to a
// phone/PC clock that's a few minutes off would make "just now" read "3m ago".
export function relativeTime(value, nowMs = Date.now()) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  const secs = Math.round((nowMs - d.getTime()) / 1000);
  if (secs < 45) return 'just now';
  const mins = Math.round(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.round(hours / 24);
  if (days < 30) return `${days}d ago`;
  const months = Math.round(days / 30);
  if (months < 12) return `${months}mo ago`;
  return `${Math.round(months / 12)}y ago`;
}

/** Whole minutes between `value` and `nowMs` (Infinity when unparseable). */
export function minutesSince(value, nowMs = Date.now()) {
  if (!value) return Infinity;
  const t = new Date(value).getTime();
  if (Number.isNaN(t)) return Infinity;
  return Math.max(0, (nowMs - t) / 60000);
}
